<template>
    <div>

    <div class="intertiscial">
        <div id="sas_35709" v-if="company.WWOTTInterstitial !=null">
            <script2>{{company.WWOTTInterstitial}}</script2>
            </div>
    </div>

      <div class="space-web visible-lg visible-md"></div>
      <div class="space-mobil visible-xs visible-sm"></div>
      <!-- Termina Space -->

      <!-- Buscador Movil -->
      <div class="container">
          <div class="row">
              <div class="col-sm-12">
            <div class="busqueda-contenido2 visible-sm visible-xs">

              <form role="form" @submit.prevent="simpleSearch" method="get" >
              <ul class="list-inline">
                <li style="width: 77%;"><input v-model="simpleSearchInput"  @keyup="getList" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                <!-- <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li> -->
              </ul>
               <div class="autocomplete" v-show="isOpen" >
                                      <ul class="autocomplete-results">
                                          <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                            {{ result.nameRecord }}
                                          </li>
                                      </ul>
                                 </div>
               <div class="radio-ww animated slideInRight visible-sm visible-xs">
                <!-- <label class="radio-inline">
                    <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                    </label> -->
                  <!-- <label class="radio-inline">
                    <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="guia">OTT
                </label> -->
             </div> 
              </form>

            </div>
            <!-- <div class="busq-avanzada">
              <div id="busqavanzada2" class="collapse">
                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                  <div class="form-group">
                  <div class="col-sm-12">
                    <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                  </div>
                  </div>
                  <div class="form-group">
                  <div class="col-sm-12">
                    <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                  </div>
                  </div>
                  <div class="form-group">
                  <div class="col-sm-12">
                    <select class="form-control" name="country" v-model="countryIn"  >
                    <option :value="0" selected >-- País --</option>
                    <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                    </select>
                  </div>
                  </div>
                  <div class="form-group">
                  <div class="col-sm-12">
                    <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                    <option  :value="0"  selected >-- Categoría --</option>
                    <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                    </select>
                  </div>
                  </div>
                  <div class="form-group">
                  <div class="col-sm-12">
                    <select class="form-control" name="activity" v-model="activityIn" >
                    <option  :value="0"  selected >-- Actividad --</option>
                    <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                    </select>
                  </div>
                  </div>
                </form>
              </div>
            </div> -->
          </div>
          </div>
      </div>

     <!-- Banner Horizontal -->
      <div class="banner visible-lg visible-md animated slideInDown">
          <div class="container" v-if="company.WWonlineBannerTopOTTFM!=null">
            <div id="sas_31458" >
            <script2>{{company.WWonlineBannerTopOTTFM}}</script2>
            </div>
          </div>
      </div>

      <!-- Contenido -->
      <div class="contenido-resultados" >
          <div class="container">
              <div class="row">
                 <div class="col-md-8">
                      <!-- Ficha Empresa -->
                      <div class="contacto-empresa animated slideInLeft">
                          <div class="row"  v-if="(typeof company !== 'undefined' )" >
                              <div class="col-md-4" align="center">
                                  <div class="imagen-persona-empresa" >
                                      <router-link  :to="'/empresaOTT/'+company.permalink" >
                                            <img :src="'https://images.produ.com/logos/'+getVerticalContact(company.Images)" width="100%"></img>
                                      </router-link>
                                  </div>
                              </div>
                              <div class="col-md-8 info-resultado"  >
                                  <router-link  :to="'/empresaOTT/'+companyID" v-if="(typeof company !== 'undefined' ) && company">
                                      <h1 v-html="company.CompanyName"  v-if="company.CompanyName" ></h1>
                                  </router-link>
                                  <p class="year" v-if="company.FundacionYear > 0">Año de fundación : <span v-html="company.FundacionYear"></span></p>
                                  <h2 v-html="company.NombreCategory"  v-if="company.NombreCategory"  ></h2>

                                  <p v-html="company.Address1"   v-if="company.Address1"  ></p>
                                  <p v-html="company.citiName" v-if="company.citiName"  ></p>

                                  <p v-if="company.Telefono1"> {{ company.CodAreaT1 | addPlusSign }} {{company.Telefono1}}</p>
                                  <p v-if="company.Fax1"> {{ company.CodAreaF1 | addPlusSign }} {{company.Fax1}}</p>
                                  
                                  <p  v-html="company.URL"  v-if="(typeof company.URL !== 'undefined' )" >www.televisa.com</p>
                                  <p><strong>Actividad de la Empresa</strong></p>
                                  <p v-html="company.NombreCategory"   v-if="company.NombreCategory" ></p>
                                 <p v-if="company.Descripcion && company.Descripcion.length"><strong>Descripción de la empresa:</strong></p>
                                  <p v-html="company.Descripcion"  v-if="company.Descripcion && company.Descripcion.length"></p>
                                  <p v-if="company.Especialidad && company.Especialidad.length"><strong>Especialidad:</strong></p>
                                  <p v-html="company.Especialidad"  v-if="company.Especialidad && company.Especialidad.length"></p>

                                  <div class="icons-contacto">
                                      <!-- <ul class="list-inline">
                                          <li><a href="" data-toggle="modal" data-target="#ModalContacto"><i class="fa fa-envelope"></i></a> </li>
                                          <li><a href="tel:+1-303-499-7111"><i class="fa fa-phone"></i></a></li>
                                          <li><a href="" data-toggle="modal" data-target="#ModalCompartir"><i class="fa fa-share-alt visible-xs visible-sm"></i></a> </li>
                                          <div class="share-new pull-right visible-lg visible-md" style="color:#000000;font-weight: bold;">
                                              <li ><i class="fa fa-share-alt"></i></li>
                                              <div class="share-buble">
                                                  <p><a href="#" class="facebook"><i class="fa fa-facebook" aria-hidden="true" style="font-size: 15px;"></i><span>Facebook</span></a></p>
                                                  <p><a href="#" class="twitter"><i class="fa fa-twitter" aria-hidden="true" style="font-size: 15px;"></i><span>Twitter</span></a></p>
                                                  <p><a href="#" class="whatsapp"><i class="fa fa-whatsapp" aria-hidden="true" style="font-size: 15px;"></i><span>Whatsapp</span></a></p>
                                                  <p><a href="#" class="g-plus"><i class="fa fa-google" aria-hidden="true" style="font-size: 15px;"></i><span>Gmail</span></a></p>
                                              </div>
                                          </div>
                                      </ul> -->
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- Ficha Persona -->
                      <div class="contacto-persona animated slideInLeft" v-if="contacts.length > 0">
                          <div class="row" v-if="contact && (typeof contact !== 'undefined' )" >
                              <div class="col-md-4" align="center">
                                  <div class="imagen-persona-contacto" >
                                      <router-link  :to="'/contacto/'+contact.permalink" >

                                          <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/ww/'+ getVerticalContact(contact.Images)+')' }" ></div>
                                      </router-link>
                                  </div>
                              </div>
                              <div class="col-md-8 info-resultado">
                                  <router-link  :to="'/contacto/'+contact.permalink" >
                                      <h1 v-html="contact.nameRecord" ></h1>
                                  </router-link>
                                  <h2 v-html="contact.Title"  ></h2>
                                  <router-link  :to="'/empresaOTT/'+companyID" >
                                    <h3 v-html="company.CompanyName"  ></h3>
                                  </router-link>
                                  <p  v-html="company.NombreCategory"></p>
                                  <div class="icons-contacto">
                                      <!-- <ul class="list-inline">
                                          <li><a href="" data-toggle="modal" data-target="#ModalContacto"><i class="fa fa-envelope"></i></a> </li>
                                          <li><a href="tel:+1-303-499-7111"><i class="fa fa-phone"></i></a></li>
                                          <li><a href="" data-toggle="modal" data-target="#ModalCompartir"><i class="fa fa-share-alt visible-xs visible-sm"></i></a> </li>
                                          <div class="share-new pull-right visible-lg visible-md" style="color:#000000;font-weight: bold;">
                                              <li ><i class="fa fa-share-alt"></i></li>
                                              <div class="share-buble">
                                                  <p><a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.facebook.com/sharer/sharer.php?u=http://who.produ.com/contacto/'+contact.permalink" class="facebook"><i class="fa fa-facebook" aria-hidden="true" style="font-size: 15px;"></i><span>Facebook</span></a></p>
                                                  <p><a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://twitter.com/intent/tweet?status='+contact.FirstName+' '+contact.LastName+'http://who.produ.com/contacto/'+contact.permalink+'&title='+contact.FirstName+' '+contact.LastName"  class="twitter"><i class="fa fa-twitter" aria-hidden="true" style="font-size: 15px;"></i><span>Twitter</span></a></p>
                                                  <p><a onclick="window.open(this.href, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" :href="'http://www.linkedin.com/shareArticle?mini=true&url=http://who.produ.com/contacto/'+contact.permalink+'&title='+contact.FirstName+' '+contact.LastName+'&source=http://who.produ.com'" class="whatsapp"><i class="fa fa-whatsapp" aria-hidden="true" style="font-size: 15px;"></i><span>Whatsapp</span></a></p>
                                                  <p><a href="#" class="g-plus"><i class="fa fa-google" aria-hidden="true" style="font-size: 15px;"></i><span>Gmail</span></a></p>
                                              </div>
                                          </div>
                                      </ul> -->
                                  </div>
                              </div>
                          </div>
                      </div>



                      <app-content></app-content>

                    </div>
                    <div class="col-md-4 animated slideInRight">
                        <!-- Busqueda Web -->
                     <form role="form" @submit.prevent="simpleSearch" method="get" >
                        <div class="busqueda-contenido visible-lg visible-md">
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput" @keyup="getList"  autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                <!-- <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada"><i class="fa fa-plus"></i></button></li> -->
                            </ul>
                            <div class="autocomplete" v-show="isOpen" >
                                      <ul class="autocomplete-results">
                                          <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                            {{ result.nameRecord }}
                                          </li>
                                      </ul>
                                 </div>
                          <div class="radio-ww animated slideInRight">
                              <!-- <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                                </label> -->
                                <!-- <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  id="ott" value="guia">OTT
                              </label> -->
                         </div>
                        </div>
                     </form>
                        <!-- Busqueda Avanzada Web -->
                        <!-- <div class="busq-avanzada">
                            <div id="busqavanzada" class="collapse">
                                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                          <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                        </div>
                                        </div>
                                        <div class="form-group">
                                        <div class="col-sm-12">
                                          <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                        </div>
                                        </div>
                                        <div class="form-group">
                                        <div class="col-sm-12">
                                          <select class="form-control" name="country" v-model="countryIn"  >
                                          <option :value="0" selected >-- País --</option>
                                          <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                          </select>
                                        </div>
                                        </div>
                                        <div class="form-group">
                                        <div class="col-sm-12">
                                          <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                          <option  :value="0"  selected >-- Categoría --</option>
                                          <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                          </select>
                                        </div>
                                        </div>
                                        <div class="form-group">
                                        <div class="col-sm-12">
                                          <select class="form-control" name="activity" v-model="activityIn" >
                                          <option  :value="0"  selected >-- Actividad --</option>
                                          <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                          </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> -->
                    

                    <div class="banner">
                        <div id="sas_31459" v-if="company.WWonlineBannerLat1OTTFM !=null">
                         <script2>{{company.WWonlineBannerLat1OTTFM}}</script2>
                          </div>
                    </div>

                        <!-- Empresas -->
                        <div class="empresa"  v-if="contactCompanies[0] && (typeof contactCompanies !== 'undefined' ) ">
                            <h1>EMPRESA</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <div class="lista-empresa">
                                    <router-link :to="'/empresa/'+contactCompanies[0].permalink" >
                                    <h2  v-html="contactCompanies[0].CompanyName" ></h2>
                                  </router-link>
                                  <p v-html="contactCompanies[0].Address1" > </p>
                                  <p  >Tel: {{ contactCompanies[0].CodAreaT1+' '+contactCompanies[0].Telefono1 }}</p>
                                  <p >Fax: {{ contactCompanies[0].CodAreaT1+' '+contactCompanies[0].Fax1 }}</p>
                                  <p><strong v-html="contactCompanies[0].Email"  ></strong></p>
                                  <a :href="contactCompanies[0].URL"> <p><strong v-html="contactCompanies[0].URL" > </strong></p>   </a>
                              </div>
                              <hr>
                            </div>
                            <br>
                            <!-- Empresas Relacionadas -->
                            <h1>EMPRESAS RELACIONADAS</h1>
                            <hr>
                            <div class="scroll-empresa" v-if="contactCompanies && contactCompanies.length > 1">
                                 <template v-for="(tmp,key) in contactCompanies" v-if="key > 0 && contactCompanies">
                                  <div class="lista-empresa-relacionada">
                                    <router-link :to="'/empresa/'+tmp.permalink" >
                                      <h2 v-html="tmp.CompanyName" ></h2>
                                    </router-link>
                                    <p v-html="tmp.Address1" > </p>
                                    <p  >Tel: {{ tmp.CodAreaT1+' '+tmp.Telefono1 }}</p>
                                    <p >Fax: {{ tmp.CodAreaT1+' '+tmp.Fax1 }}</p>
                                    <a :href="tmp.URL"><p><strong v-html="tmp.URL" ></strong></p></a>
                                  </div>
                                  <hr>
                                </template>
                            </div>
                        </div>
                        <!-- Ejecutivos -->
                        <div class="ejecutivo" v-if="contacts.length > 0">
                            <h1>EJECUTIVOS</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <template v-for="tmp in contacts" v-if="(contacts !== 'undefined' ) && contacts">
                                    <div class="lista-ejecutivos">
                                      <router-link :to="'/contacto/'+tmp.permalink" >
                                        <h2 v-html="tmp.nameRecord" style="text-align: left !important"></h2>
                                      </router-link>
                                      <p v-html="tmp.Title">ejecutiva de Medios</p>
                                    </div>
                                    <hr>
                                </template>
                            </div>
                        </div>
                   </div>
         
    
                      <!-- Reels -->
                      <div class="reel"  v-if="contactVideos.length > 0 && (typeof contactVideos !== 'undefined' )  ">
                          <h1>REELS</h1>
                          <hr>
                          <div class="scroll-reel">
                            <template v-for="tmp in contactVideos" v-if="contactVideos && (typeof contactVideos !== 'undefined' )" >

                                <div class="lista-ejecutivos">
                                  <a :href="'http://www1.produ.com/videos'+contactVideos.IdVideo">
                                    <h2 v-html="tmp.Titulo"></h2>
                                  </a>
                                  <div class="imagen-reel" >
                                    <a :href="'http://www1.produ.com/videos'+contactVideos.IdVideo">
                                      <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/videos/'+( (contactVideos.Subfolder) ? contactVideos.Subfolder+'/' : '' )+ contactVideos.Ubicacion+')' }" ></div>
                                    </a>
                                  </div>
                                </div>
                                <hr>
                              </template>
                          </div>
                      </div>
                      
                 </div>
              </div>
          </div>
      </div>

    </div>
</template>

<script>
var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';

// var resfulApi="http://produbackend/admin/index.php/welcome/";
import axios from 'axios';

import Content from './company/Content.vue';

export default {
    name: 'CompanyOTT',
    components: {
        'app-content': Content,
    },
    data() {
        return {
            simpleSearchInput: '',
            countries: [],
            categories: [],
            activities: [],
            categoryIn: 0,
            contactoIn: '',
            empresaIn: '',
            countryIn: 0,
            activityIn: 0,

            companyID: 0,
            contactID: 0,
            company: [],
            contactCompanies: [],
            companies: [],
            contact: [],
            contactVideos: [],
            isMobile: false,
            contacts: [],
            selectedSearchIn: 'ww',
            isOpen: false,
            contactos: [],
            permalink: 0,
            nombres: '',
        };
    },
    created() {},
    methods: {
        moment: function() {
            return moment();
        },
        getCompany: async function(companyID) {
            this.companyID = companyID;

            await axios
                .post(resfulApi + 'getCompanyWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    companyIN: this.companyID,
                    contactOTT: 1,
                })
                .then(response => {
                    this.company = response.data.company;
                    console.log(this.company);
                    this.companies = response.data.companies;
                    if (
                        response.data.contacts[0] &&
                        response.data.contacts !== 'undefined'
                    ) {
                        this.contact = response.data.contacts[0];
                        this.contacts = response.data.contacts;

                        this.contactID = this.contact.IdContactFM;
                    }

                    this.$nextTick(function() {});
                });
        },
        getVideosByCompanyWS: async function(companyID, pageIN) {
            this.companyID = companyID;

            await axios
                .post(resfulApi + 'get_VideosCompaniesWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    companyIN: this.companyID,
                    typeIN: 1,
                    pageIN: 0,
                })
                .then(response => {
                    this.contactVideos = response.data.result;
                    this.$nextTick(function() {});
                });
        },
        advanceSearch: async function(page) {
            this.currentPage = page;
            this.$router.push(
                '/advancesearch/' +
                    this.contactoIn +
                    '_' +
                    this.empresaIn +
                    '_' +
                    this.countryIn +
                    '_' +
                    this.categoryIn +
                    '_' +
                    this.activityIn
            );
        },
        isActiveSearch() {
            return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                ? false
                : true;
        },
        simpleSearch: function(e) {
            if (this.simpleSearchInput && this.isActiveSearch()) {
                this.nombres =
                    this.nombres == '' ? this.simpleSearchInput : this.nombres;
                this.$router.push({
                    name: 'Search',
                    params: {
                        permalink: this.permalink,
                        tipo: this.selectedSearchIn,
                        search: this.simpleSearchInput,
                        nombres: this.nombres,
                    },
                });
            }
        },
        getDataForm: async function() {
            await axios
                .post(resfulApi + 'getCountriesWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(response => {
                    this.countries = response.data.countries;
                    this.categories = response.data.categories;

                    this.$nextTick(function() {});
                });

            this.getActivity();
        },
        getActivity: async function() {
            if (this.categoryIn) {
                await axios
                    .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        category: this.categoryIn,
                    })
                    .then(response => {
                        this.activities = response.data;

                        this.$nextTick(function() {});
                    });
            }
        },
        getDataClick: async function(newVal) {
            this.companyID = newVal;
            this.$route.params.empresa = this.companyID;
            this.getCompany(newVal);
            this.getVideosByCompanyWS(this.companyID);
        },
        getList: function() {
            this.simpleSearchInput.length > 3
                ? this.getSearchWWFWS()
                : (this.isOpen = false);
        },
        getSearchWWFWS: async function() {
            await axios
                .post(resfulApi + 'getSearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: this.simpleSearchInput,
                    tipo: this.selectedSearchIn,
                })
                .then(response => {
                    this.contactos = response.data;
                    this.contactos.length > 0
                        ? (this.isOpen = true)
                        : (this.isOpen = false);
                });
        },
        setResult: async function(result) {
            this.simpleSearchInput = result.nombres;
            this.permalink = result.permalink;
            this.nombres = result.nombres;
            this.isOpen = false;
            var typeSearch = this.redirectConsulta(
                result.nameRecord,
                result.GuiaOTT
            );
            this.$router.push('/' + typeSearch + '/' + result.permalink);
        },
    },
    beforeMount() {},
    mounted: function() {
        this.companyID = this.$route.params.empresa;

        this.getCompany(this.companyID);
        this.isMobile = this.checkMobile();

        this.getVideosByCompanyWS(this.companyID);
        this.getDataForm();
    },
    watch: {
        '$route.params.empresa'(newId, oldId) {
            this.companyID = newId;
            this.isMobile = this.checkMobile();

            this.getCompany(this.companyID);
            this.getVideosByCompanyWS(this.companyID);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filtro-negro a:hover {
    cursor: pointer;
}

a:hover {
    cursor: pointer;
}

@media only screen and (max-width: 650px) {
    .blog-content img,
    h1,
    h3,
    a,
    h4 {
        text-align: center !important;
    }

    .container-who-who {
        float: left;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyOTT.vue